import styles from "./bonuses-popup.module.scss";
import ReactMarkdown from "react-markdown";
import { Fragment, useRef, useState, useMemo, useContext, useEffect } from 'react';
import { IBonus } from "../../../interfaces/bonus.interface";
import { BonusList } from "../../common/bonus-list/bonus-list";
import { useMediaQuery } from "react-responsive";
import classNames from "classnames";
import { Animate } from "../../animation/animation";
import { useAppSelector } from "../../../hooks/redux.hook";
import { useSize } from "../../../hooks/use-size.hook";
import { useCustomStylesOnHover } from "../../../hooks/use-custom-styles-on-hover.hook";
import { StylesContext } from "../../../contexts/styles-context/styles.context";
import giftImage from "../../../assets/img/gift.png";

interface BonusesPopupProps {
  active: boolean;
  bonuses: IBonus[]
}

const defaultBonusButtonBackground = `linear-gradient(197.93deg, #83A4FA -110.54%, #83A4FA -20.28%, #567BF6 53.14%, #4A70F4 115.86%, #4266E3 183.17%)`;

export function BonusesPopup(props: React.PropsWithChildren<BonusesPopupProps>) {
  const { bonuses, active } = props;
  const screenWidth1024 = useMediaQuery({ maxWidth: 1024 });
  const header = screenWidth1024 ? "Ваши бонусы" : "Вы получите после прохождения опроса";
  const contentRef = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);
  const headerRect = useAppSelector(state => state.quiz.questionHeaderRect);
  const { size: buttonSize, getNode } = useSize();

  const { styles: customStyles } = useContext(StylesContext);
  const [buttonBackground, setButtonBackground] = useState(defaultBonusButtonBackground);

  const top = useMemo(() => {
    return headerRect?.top + headerRect?.height / 2 - buttonSize?.height / 2
  }, [headerRect?.top, headerRect?.height, buttonSize?.height]);

  const clickHandler = () => {
    setOpen(!open);
  }

  useEffect(() => {
    if (customStyles.primaryButtons?.background) {
      setButtonBackground((customStyles.primaryButtons as any)?.background);
    }
  }, [customStyles.primaryButtons]);

  return (<>
    <Animate when={open} timeout={{ appear: 0, enter: 0, exit: 600 }} duration={600} unmountOnExit={true} animation={'half_fade'}>
      <div className={classNames(styles.underlay)} onClick={clickHandler}></div>
    </Animate>
    <Animate when={open} timeout={{ appear: 0, enter: 0, exit: 600 }} duration={600} animation={'go_left'}>
      <div className={classNames(styles.window, { [styles.active]: active })} style={{ top: top + "px" }}>
        <div
          ref={getNode}
          className={classNames(styles.button)}
          style={{
            background: buttonBackground,
            backgroundPosition: "center",
            backgroundSize: "100%"
          }}
          onClick={clickHandler}
        ></div>
        <div ref={contentRef} className={styles.container} onClick={clickHandler}>
          <h2 className={styles.header}>
            <ReactMarkdown
              source={header}
              escapeHtml={false}
              renderers={{ paragraph: props => <Fragment children={props.children} /> }}
            />
          </h2>
          <BonusList
            bonuses={bonuses}
            active={true}
            mode={"block"}
          />
        </div>
      </div>
    </Animate>
  </>
  )
}